import { SuggestedChangeDataSet } from '@schooly/constants';
import { TypographyWithOverflowHint } from '@schooly/style';
import React, { FC } from 'react';

import { LongStringWithTooltip } from '../../../../components/uikit-components/LongStringWithTooltip/LongStringWithTooltip';
import { useProfile } from '../../../../context/profile/useProfile';
import ProfileProperty from '../ProfileProperty';
import { CustomFieldPropertyProps } from './CustomFieldPropertyProps';
import { CustomFieldSelectModal } from './CustomFieldSelectModal';

export const CustomFieldSelectProperty: FC<CustomFieldPropertyProps> = ({
  size = 'sm',
  color = 'gray',
  iconColor = 'light-gray',
  value,
  hideSuggestedChanges,
  onClick,
  onClose,
  ...field
}) => {
  const { hasEditingPermission } = useProfile();

  const selectedValue = (value?.value as string[])?.[0];

  const handleClose = (fn: () => void) => {
    fn();
    onClose?.();
  };

  return (
    <ProfileProperty
      value={selectedValue}
      canEdit={hasEditingPermission}
      params={{ size, iconColor, color }}
      renderLabel={() => <LongStringWithTooltip>{field.label}</LongStringWithTooltip>}
      renderValue={() => (
        <TypographyWithOverflowHint variant="h3" color="text.primary" noWrap>
          {selectedValue}
        </TypographyWithOverflowHint>
      )}
      valueText={field.label}
      editValueText={field.label}
      dataSet={SuggestedChangeDataSet.Telephones}
      hideSuggestedChanges={hideSuggestedChanges}
      modalController={({ isOpen, hide }) => (
        <CustomFieldSelectModal
          isOpen={isOpen}
          onClose={() => handleClose(hide)}
          field={field}
          value={value}
          options={field.select_type_options}
        />
      )}
      onClick={onClick}
    />
  );
};
